import { render, staticRenderFns } from "./PolicyContent.vue?vue&type=template&id=27c13172&scoped=true&"
import script from "./PolicyContent.vue?vue&type=script&lang=ts&"
export * from "./PolicyContent.vue?vue&type=script&lang=ts&"
import style0 from "./PolicyContent.vue?vue&type=style&index=0&id=27c13172&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c13172",
  null
  
)

export default component.exports